import React from 'react';
import { UpdateIcon } from '../../../icon/icons/update';
import { ActionPressedChip } from '../atoms/action-pressed-chip';

type UndoActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const UndoAction = ({ compact = true, showBoxShadow = true, ...rest }: UndoActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <UpdateIcon size={16} />
    </ActionPressedChip>
  );
};
